module.exports = __webpack_public_path__ + "static/media/next.60f04403.svg";